/* eslint-disable @reatom/unit-naming-rule */
import { withAssign } from '@reatom/framework'

import { Result } from '@blade/std-lib'
import { fetchPairRequestAction } from '@root/entities/pair/atoms'
import { reatomResource } from '@root/shared/lib'

import { pairRegistry } from './pair-registry'

import type { PairAddress } from '../model'
import type { Network } from '@root/entities/network/model'

export const reatomPairResource = ({
  pairAddress,
  network,
  loadOnConnect,
}: {
  pairAddress: PairAddress
  network: Network.Network
  loadOnConnect?: boolean
}) => {
  const pairStateAtom = reatomResource(
    async (ctx) => {
      const cached = pairRegistry.get(pairAddress, network)
      if (cached) {
        return Result.succeed(cached)
      }
      const result = await ctx.schedule(() =>
        fetchPairRequestAction(ctx, { address: pairAddress, network }),
      )
      return result.pipe(
        Result.map((it) => pairRegistry.resolveFromDto(ctx, it)),
      )
    },
    {
      name: `reatomPairResource.${pairAddress.toString()}.${network.toString()}`,
      loadOnConnect,
    },
  )

  return pairStateAtom.pipe(
    withAssign(() => ({
      pairAddress,
      network,
    })),
  )
}
